webpackJsonp([162898551421021],{

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FactLoader = function FactLoader(_ref) {
	  var facts = _ref.facts;
	
	  var getRandomFact = function getRandomFact() {
	    return facts[Math.floor(Math.random() * facts.length)];
	  };
	
	  var activeFact = getRandomFact();
	  var _activeFact$node = activeFact.node,
	      header = _activeFact$node.header,
	      fact = _activeFact$node.fact,
	      _activeFact$node$link = _activeFact$node.link,
	      title = _activeFact$node$link.title,
	      path = _activeFact$node$link.url.path;
	
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'facts' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'fact__title' },
	      header
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'fact__description' },
	      fact
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: path,
	        className: 'btn btn--secondary-outline btn--icon-right',
	        target: '_blank'
	      },
	      title,
	      _react2.default.createElement('span', { className: 'fas fa-long-arrow-alt-right' })
	    )
	  );
	};
	
	exports.default = FactLoader;
	
	
	FactLoader.propTypes = {
	  facts: _propTypes2.default.array.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	var _factLoader = __webpack_require__(405);
	
	var _factLoader2 = _interopRequireDefault(_factLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper--page-dark page--404' },
	    _react2.default.createElement(
	      'div',
	      { className: 'page-main' },
	      _react2.default.createElement(_headerNew2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper--max-width' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page-header' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Oops, that doesn\'t exist'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We can\'t find the page you were looking for.'
	          )
	        ),
	        _react2.default.createElement(_factLoader2.default, { facts: data.allDrupalFact.edges })
	      )
	    ),
	    _react2.default.createElement(_footerNew2.default, { theme: 'dark' })
	  );
	}; /* global graphql  */
	exports.default = NotFoundPage;
	
	
	NotFoundPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-905262f3ac4caee06265.js